/**
 * HapticsService - Respuesta Háptica Táctil para Dispositivos Móviles
 * Compatible con Capacitor Haptics y Web Vibration API
 */

class HapticsServiceManager {
    constructor() {
        this.isSupported = typeof navigator !== 'undefined' && 'vibrate' in navigator;
    }

    /**
     * Vibrate/Impact feedback
     * @param {'light' | 'medium' | 'heavy'} style 
     */
    impact(style = 'light') {
        try {
            if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Haptics) {
                window.Capacitor.Plugins.Haptics.impact({ style: style.toUpperCase() });
                return;
            }

            if (this.isSupported) {
                const durations = { light: 15, medium: 30, heavy: 50 };
                navigator.vibrate(durations[style] || 15);
            }
        } catch (_e) {
            // Ignorar silenciosamente si las vibraciones están bloqueadas por el navegador
        }
    }

    /**
     * Selection feedback (ej. cambiar entre opciones o fichas)
     */
    selection() {
        this.impact('light');
    }

    /**
     * Notification feedback (éxito o error)
     * @param {'success' | 'warning' | 'error'} type 
     */
    notification(type = 'success') {
        try {
            if (window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Haptics) {
                window.Capacitor.Plugins.Haptics.notification({ type: type.toUpperCase() });
                return;
            }

            if (this.isSupported) {
                const patterns = {
                    success: [20, 50, 20],
                    warning: [40, 60, 40],
                    error: [60, 80, 60, 80]
                };
                navigator.vibrate(patterns[type] || [20, 50, 20]);
            }
        } catch (_e) {
            // Ignorar silenciosamente
        }
    }
}

export const HapticsService = new HapticsServiceManager();

// Exponer en la jerarquía global de Detectimáticas
if (typeof window !== 'undefined') {
    window.Detectimaticas = window.Detectimaticas || {};
    window.Detectimaticas.HapticsService = HapticsService;
    window.HapticsService = HapticsService;
}
